export default __webpack_public_path__ + "static/media/pink-circle-outline.96c31f29.png";